import styled from 'styled-components';
import { themeColor } from '@hud/web-components/theme/colors';
import { mdRegular } from '@hud/web-components/theme/typography';
import { HudIcon } from '@hud/web-components/Icons/HudIcons';

export const KeyIcon = styled(HudIcon).attrs({
  size: '20px',
  icon: 'other.key',
})<{ icon?: never }>`
  color: #0ffbe4;
`;

export const KeysContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const KeyContainer = styled.div`
  padding: 14px;
  border: 1px solid ${themeColor('strokeSecondary')};
  border-radius: 12px;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.2);

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const KeyTitle = styled.h3`
  margin: 0;
  ${mdRegular};
  color: ${themeColor('textPrimary')};
`;

export const KeyValueContainer = styled.div`
  display: flex;
  align-items: center;
  padding: 8px;
  background: ${themeColor('buttonBackground')};
  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  gap: 8px;
`;

export const KeyValue = styled.code`
  flex: 1;
  font-family: monospace;
  color: ${themeColor('textPrimary')};
  overflow: hidden;
  text-overflow: ellipsis;
`;
